import Script from 'next/script';

const Scripts = (): React.JSX.Element | null => {
  return (
    <Script
      id="dreamdata-iframe"
      src="https://cdn.dreamdata.cloud/scripts/analytics/next/iframe-identify-form.js"
      strategy="afterInteractive"
    />
  );
};

export default Scripts;
